/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Overlap_ProtectionInputs */



/**
* | output |
* | --- |
* | "Overlap Protection" |
*
* @param {Options_Editor_Overlap_ProtectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_overlap_protection = /** @type {((inputs?: Options_Editor_Overlap_ProtectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Overlap_ProtectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Protection contre le chevauchement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überlappungsschutz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Protezione da sovrapposizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Защита от перекрытия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Protección contra superposiciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重叠保护")
	if (locale === "ja") return /** @type {LocalizedString} */ ("重複保護")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओवरलैप सुरक्षा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Proteção contra sobreposição")
	return /** @type {LocalizedString} */ ("Overlap Protection")
});